import { useEffect } from "react";

const useScrollRestoration = (isReady: boolean, auctionPartId: number) => {
    useEffect(() => {
        if (!isReady) return;
        if (typeof window === "undefined") return;

        const storageKey = `lastViewedItem-${auctionPartId}`;
        const savedItemId = sessionStorage.getItem(storageKey);

        if (!savedItemId) return;

        const targetElementId = `auction-item-card-${savedItemId}`;
        let attempts = 0;
        const maxAttempts = 120;

        const tryScroll = () => {
            const targetElement = document.getElementById(targetElementId);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "auto", block: "center" });
                sessionStorage.removeItem(storageKey);
                return;
            }

            attempts += 1;
            if (attempts < maxAttempts) {
                requestAnimationFrame(tryScroll);
            }
        };

        tryScroll();
    }, [isReady, auctionPartId]);
};

export default useScrollRestoration;
